module.exports = __webpack_public_path__ + "img/highco.2e5fe986.png";